import type { ShowingRequestPropertyQuery_marketplace_MarketplaceQuery_property_MarketplaceProperty as Property } from 'buying/graphql/queries/__generated__/ShowingRequestProperty';
import { assign, createMachine } from 'xstate';

interface ShowingRequestCreationContext {
  addressId?: string;
  property?: Property;
}

export const ShowingRequestCreationStateMachine = createMachine<ShowingRequestCreationContext>(
  {
    context: {
      addressId: undefined,
    },
    schema: {
      events: {} as
        | { type: 'setAddressId'; value: string }
        | { type: 'setProperty'; value: Property },
    },
    id: 'showing-request-creation',
    initial: 'IDLE',
    states: {
      IDLE: {
        on: {
          FORWARD: {
            target: 'PROPERTY_CONFIRM',
            cond: (context) => context.addressId !== undefined,
          },
          setAddressId: {
            actions: 'setAddressId',
          },
          setProperty: {
            actions: 'setProperty',
          },
        },
      },
      PROPERTY_CONFIRM: {
        on: {
          FORWARD: [
            {
              target: 'DOWNLOAD_APP',
              cond: (context) => context.property?.instantTours === true,
            },
            {
              target: 'REDIRECT',
              cond: (context) => context.property?.instantTours !== true,
            },
          ],
        },
      },
      DOWNLOAD_APP: {
        on: {
          FORWARD: {
            target: 'APP_REDIRECT',
          },
        },
      },
      REDIRECT: {
        type: 'final',
      },
      APP_REDIRECT: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      setAddressId: assign({
        addressId: (_, event) => event.value,
      }),
      setProperty: assign({
        property: (_, event) => event.value,
      }),
    },
  },
);
